


function isDeviceOnline(deviceID = [], siteName = "") {
    if (siteName === "") return false;
    if (deviceID.length === 0) return false;
    for (let u = 0; u < deviceID.length; u++) {
        if (deviceID[u]['deviceName'] === siteName) {
            return deviceID[u]['online'];
        }
    }
}

export {isDeviceOnline};


// WEBPACK FOOTER //
// ./src/utils/isDeviceOnline.js